export let yearSingularAbbreviation = "QeZblb";
export let yearFirstPluralAbbreviation = "XUYe5c";
export let yearSecondGenitivePluralAbbreviation = "ITp63b";
export let monthSingularAbbreviation = "bwCXYd";
export let monthFirstPluralAbbreviation = "MQMxh";
export let monthSecondGenitivePluralAbbreviation = "h6iDFb";
export let weekSingularAbbreviation = "JXL2re";
export let weekFirstPluralAbbreviation = "YAyY7";
export let weekSecondGenitivePluralAbbreviation = "nFEVwc";
export let daySingularAbbreviation = "DwqHX";
export let dayFirstPluralAbbreviation = "IgT_Pd";
export let daySecondGenitivePluralAbbreviation = "nlaLJb";
export let hourSingularAbbreviation = "n6rFod";
export let hourFirstPluralAbbreviation = "W13x6c";
export let hourSecondGenitivePluralAbbreviation = "lQxvgb";
export let hourSimplifiedPluralAbbreviation = "mJotf";
export let minuteSingularAbbreviation = "TY9IZ";
export let minuteFirstPluralAbbreviation = "mJuPid";
export let minuteSecondGenitivePluralAbbreviation = "P1lFkc";
export let minuteSimplifiedPluralAbbreviation = "ssgt0c";
export let secondSingularAbbreviation = "B98Co";
export let secondFirstPluralAbbreviation = "Gfnpdc";
export let secondSecondGenitivePluralAbbreviation = "Rc46yd";
export let secondSimplifiedPluralAbbreviation = "GTapJd";
export default {yearSingularAbbreviation,yearFirstPluralAbbreviation,yearSecondGenitivePluralAbbreviation,monthSingularAbbreviation,monthFirstPluralAbbreviation,monthSecondGenitivePluralAbbreviation,weekSingularAbbreviation,weekFirstPluralAbbreviation,weekSecondGenitivePluralAbbreviation,daySingularAbbreviation,dayFirstPluralAbbreviation,daySecondGenitivePluralAbbreviation,hourSingularAbbreviation,hourFirstPluralAbbreviation,hourSecondGenitivePluralAbbreviation,hourSimplifiedPluralAbbreviation,minuteSingularAbbreviation,minuteFirstPluralAbbreviation,minuteSecondGenitivePluralAbbreviation,minuteSimplifiedPluralAbbreviation,secondSingularAbbreviation,secondFirstPluralAbbreviation,secondSecondGenitivePluralAbbreviation,secondSimplifiedPluralAbbreviation};